import React, {useEffect, useState} from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import {db} from '../../../../../firebase/Firebase';
import {useSnackbar} from 'notistack';
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";

//import '../places.css'

function capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
}

const searchOptions = {
    componentRestrictions: { country: "ec" },
}

function PlacesReservation(props) {

    const {
        setDataCoords, dataCoords, placeholder, keyData, DataStore, setRouteControl, routesControl, setRouteExist,
        setShowCalendar, setValueDate, setSelectedItemKeys, setBookings, address, setAddress, setClickControl
    } = props;

    const {companyName, idCompany, restrictZones} = DataStore;

    const [cityRoutes, setCityRoutes] = useState(null)

    const {enqueueSnackbar} = useSnackbar()

    const RouteControl = async (routeName) => {
        await db.collection(companyName).doc(idCompany).collection('Data-Routes').doc(routeName)
            .get().then(doc => {
                if (doc.exists) {
                    setRouteExist(true);
                    setShowCalendar(null);
                    setValueDate(null);
                    setSelectedItemKeys([]);
                    setBookings([]);
                } else {
                    setRouteExist(false);
                    setShowCalendar(null);
                    setValueDate(null);
                    setSelectedItemKeys([]);
                    setBookings([]);
                }
            });
    };

    useEffect(() => {
        if (routesControl.origenCity && routesControl.destinyCity) {
            const routeName = `${routesControl.origenCity}-${routesControl.destinyCity}`;
            RouteControl(routeName).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            });
        }
    }, [routesControl]);

    useEffect(() => {
        const GetRoutes = async () => {
            const routes = []
            await db.collection(companyName).doc(idCompany).collection('Routes')
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        routes.push(doc.data().origin);
                        routes.push(doc.data().destination);
                    });
                })


            const unique = new Set(routes)
            const array = [...unique]
            setCityRoutes(array)
        }

        GetRoutes().catch(() => {
            //
        });

    }, [])


    const handleSelect = async value => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        const newValue = capitalize(value);
        setAddress(newValue);
        const res = newValue.split(',').join('');
        const addressArray = res.split(' ');
        let city = '';

        if (restrictZones.length > 0) {
            restrictZones.forEach(items => {
                const result = addressArray.filter(city => city === items.id);
                if (result.length > 0) {
                    city = result[0];
                } else {
                    cityRoutes.forEach(items => {
                        const result = addressArray.filter(city => city === items);
                        if (result.length > 0) {
                            city = result[0];
                        }
                    });
                }
            });
        } else {
            cityRoutes.forEach(items => {
                const result = addressArray.filter(city => city === items);
                if (result.length > 0) {
                    city = result[0];
                }
            });
        }

        if (city === "") {
            city = res
        }


        const cityList = []

        cityRoutes.forEach(city => {
            cityList.push(city.toUpperCase())
        })

        const cityExists = cityList.includes(city.toUpperCase())
        if (!cityExists) {
            NotiStackInfo(`No existe servicio en la ciudad de ${city}`, 'warning', enqueueSnackbar)
            setShowCalendar(null);
            return
        }


        if (keyData === 'origen') {
            const keyCity = `${keyData}City`;
            setRouteControl({...routesControl, [keyCity]: city});
            setDataCoords({
                ...dataCoords, origenDirection: newValue, [keyData]: [latLng.lat, latLng.lng], [keyCity]: city
            })
            setClickControl(true)
        } else {
            const keyCity = `${keyData}City`;
            setRouteControl({...routesControl, [keyCity]: city});
            setDataCoords({
                ...dataCoords,
                destinationDirection: newValue, [keyData]: [latLng.lat, latLng.lng],
                [keyCity]: city
            });
            setClickControl(false)
        }
    };


    return (
        <div style={{width: '100%', position: 'relative'}}>
            <PlacesAutocomplete
                value={address}
                onChange={(value) => setAddress(value)}
                onSelect={handleSelect}
                googleCallbackName="initOne"
                searchOptions={searchOptions}
            >

                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (

                    <div className={'origin-place-container'}>
                        <input {...getInputProps({placeholder: placeholder})} className="places-input"/>
                        <div className={'result-autocomplete-container'}>
                            {loading ? <div>...cargando</div> : null}
                            {suggestions.map((suggestion, i) => {
                                return (
                                    <div {...getSuggestionItemProps(suggestion)} key={i}
                                         className={'result-autocomplete-container'}>
                                        <span className="places-result-span">
                                             {suggestion.description}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </div>
    );
}

export default PlacesReservation;
